import PropTypes from 'prop-types';

import ConfirmModal from '#globalComponents/Overlay/ConfirmModal';

import ContactListExportModal from '../ContactListExportModal/ContactListExportModal';
import CustomColumnModal from '../CustomColumnModal/CustomColumnModal';

const TAB_OF_TABLE = { contactListContacts: 'contacts', contactListCompanies: 'companies' };

/**
 * Dialogs of a contact-list tab's custom columns and CSV export; opened from the column picker,
 * the column header menu and the tab's action bar. State comes from useCustomColumnsTable.
 */
const CustomColumnDialogs = ({ dialogs, scopeLabel }) => {
	const { listId, table, editing, deleteTarget } = dialogs;

	return (
		<>
			<CustomColumnModal
				isOpen={Boolean(editing)}
				onClose={dialogs.closeEditor}
				column={editing?.column ?? null}
				listId={listId}
				table={table}
				previewScope={dialogs.previewScope}
				previewCount={dialogs.previewCount}
				sampleLabels={dialogs.sampleLabels}
				fillScope={dialogs.fillScope}
				fillCount={dialogs.fillCount}
				onFillStarted={dialogs.reportFillStarted}
			/>
			<ContactListExportModal
				isOpen={dialogs.exportOpen}
				onClose={dialogs.closeExport}
				listId={listId}
				tab={TAB_OF_TABLE[table]}
				scope={dialogs.fillScope}
				count={dialogs.fillCount}
				scopeLabel={scopeLabel}
			/>
			<ConfirmModal
				isOpen={Boolean(deleteTarget)}
				onClose={dialogs.cancelDelete}
				onConfirm={dialogs.confirmDelete}
				title={`Spalte „${deleteTarget?.name ?? ''}“ löschen`}
				message="Die Spalte und alle ihre Werte werden in allen Listen gelöscht. Vorlagen, die die Variable verwenden, verhindern das Löschen."
				confirmText="Löschen"
				cancelText="Abbrechen"
				isLoading={dialogs.isDeleting}
			/>
		</>
	);
};

CustomColumnDialogs.propTypes = {
	dialogs: PropTypes.object.isRequired,
	// e.g. "Aktionen für alle 161 Kontakte" — what export and fill run on.
	scopeLabel: PropTypes.string,
};

export default CustomColumnDialogs;
